import {Injectable} from '@angular/core';
import {CaseStateObserver, CaseStates} from '../domain/case-states';
import {UtilService} from './util.service';
import {LogicheckCase} from '../domain/logicheck-case';
import * as _ from 'lodash';
import {JwtDecoderService} from './jwt-decoder.service';

@Injectable({
    providedIn: 'root'
})
export class CaseStateService {

    private globalStates: CaseStates[];
    private currentStates: CaseStates;

    private caseType: string;
    private currentState: string;
    private currentStateIndex: number;

    constructor(private jwtHelper: JwtDecoderService) {
    }

    public setStates(states: CaseStates[]) {
        this.globalStates = states;
    }

    public getStates() {
        return UtilService.getObjectByValue('caseType', this.caseType, this.globalStates);
    }

    public setCaseType(caseType: string) {
        this.caseType = caseType;
        const stateObj = this.getStates();
        if (stateObj !== undefined) {
            this.currentStates = stateObj;
            this.currentStateIndex = 0;
            this.currentState = this.currentStates.states[0];
        }
    }

    public setCurrentState(state: string): boolean {
        const index = this.currentStates.states.indexOf(state);
        if (index !== -1) {
            this.currentStateIndex = index;
            this.currentState = state;
            return true;
        }
        return false;
    }

    public setStateByIndex(index: number) {
        if (index >= this.globalStates.length) {
            return false;
        }

        this.currentState = this.currentStates.states[index];
        this.currentStateIndex = index;
    }

    public proceedToNextState(state: string) {
        const statesObj = this.getStates();
        let index = statesObj.states.indexOf(state);
        if (state === 'RESULT_DATA') {

            index = statesObj.states[statesObj.states.length - 1];
            this.currentStateIndex = index;
            this.currentState = statesObj.states[this.currentStateIndex];
            return state;
        } else if (index !== -1 && index + 1 < statesObj.states.length) {
            this.currentStateIndex = index + 1;
            this.currentState = statesObj.states[this.currentStateIndex];
            return statesObj.states[this.currentStateIndex];
        }
        /* this.currentState = statesObj.states[this.currentStateIndex];
         if (this.currentStateIndex + 1 < statesObj.states.length) {
             this.currentStateIndex++;
             this.currentState = statesObj.states[this.currentStateIndex];
         }
         return this.currentState;*/
    }

    public getStateNo(state: string) {
        if (!this.currentStates) {
            return -1;
        }
        return this.currentStates.states.indexOf(state);
    }

    public getStatesForCaseType(caseType: string) {
        return _.find(this.globalStates, ['caseType', caseType]);
    }

    private checkTransitionConditions(state: string, observer: CaseStateObserver, caseType: string,
                                      destinationType: string, infoOnly: boolean): Promise<boolean> {
        return new Promise((resolve) => {
            if (!observer.checkTransitionCondition(state, caseType, destinationType)) {
                resolve(false);
            } else {
                observer.displayTransferDialog(state, caseType, infoOnly, destinationType).then((result) => {
                    resolve(result);
                });
            }
        });
    }

    public handleState(currentState, logicheckCase: LogicheckCase, observer: CaseStateObserver): void {
        const states = _.find(this.globalStates, function (o) {
            return o.caseType === logicheckCase.type;
        });
        const transitions = _.filter(states.transitions, function (o) {
            return o.states.indexOf(currentState) > -1;
        });
        let validTransition = false;
        const transferConditionPromise = new Promise<LogicheckCase>((resolve, reject) => {
            if (transitions.length === 0) {
                reject();
            }

            let responseReceived = 0;
            for (const transition of transitions) {

                const infoOnly = transition.infoOnly;
                const targetCaseType = transition.destinationType;

                this.checkTransitionConditions(currentState, observer, logicheckCase.type,
                    targetCaseType, infoOnly).then((transfer) => {
                    responseReceived++;
                    if (transfer) {
                        validTransition = true;
                        observer.getTransitionTargetCase(transition.destinationType).then((template) => {
                            const targetCase = _.cloneDeep(template);
                            for (const map of transition.dataMap) {
                                _.set(targetCase, map.targetPath, _.get(logicheckCase, map.sourcePath));
                            }
                            targetCase.state = transition.destinationState;
                            const log = {
                                type: 'Transition',
                                createdDate: new Date(),
                                createdBy: this.jwtHelper.getUsername(),
                                attributes:
                                    {
                                        fromCaseType: logicheckCase.type,
                                        fromState: logicheckCase.state,
                                        toCaseType: transition.destinationType
                                    }
                            };
                            if (!targetCase.historyLogs) {
                                targetCase.historyLogs = [];
                            }
                            if (logicheckCase.historyLogs) {
                                logicheckCase.historyLogs.forEach(el => {
                                    targetCase.historyLogs.push(el);
                                });
                            }
                            targetCase.historyLogs.push(log);
                            resolve(targetCase);
                        });
                    } else {
                        if (responseReceived === transitions.length) {
                            reject();
                        }
                    }
                });
            }


            /* const infoOnly = transition.infoOnly || false;
             this.checkTransitionConditions(currentState, observer, logicheckCase.type, infoOnly).then((transfer) => {
                 if (transfer) {
                     observer.getTransitionTargetCase(transition.destinationType).then((template) => {
                         const targetCase = _.cloneDeep(template);
                         for (const map of transition.dataMap) {
                             _.set(targetCase, map.targetPath, _.get(logicheckCase, map.sourcePath));
                         }
                         targetCase.state = transition.destinationState;
                         const log = {
                             type: 'Transition',
                             createdDate: new Date(),
                             createdBy: this.jwtHelper.getUsername(),
                             attributes:
                                 {
                                     fromCaseType: logicheckCase.type,
                                     fromState: logicheckCase.state,
                                     toCaseType: transition.destinationType
                                 }
                         };
                         if (!targetCase.historyLogs) {
                             targetCase.historyLogs = [];
                         }
                         targetCase.historyLogs.push(log);
                         resolve(targetCase);
                     });
                 } else {
                     reject();
                 }
             });*/
        });

        transferConditionPromise.then((targetCase) => {
            observer.postTransition(currentState, targetCase);
        }, () => {
            if (!validTransition) {
                observer.submit(currentState, logicheckCase.type);
            }
        });
    }

}

